// un peu crade car on le check une seule fois au chargement, mais c'est mieux que rien
export const isDarkMode = typeof globalThis.matchMedia === 'function' && globalThis.matchMedia('(prefers-color-scheme: dark)').matches // eslint-disable-line lingui/no-unlocalized-strings -- media query CSS

/*
ATTENTION à rester sync avec src/lib/style/_constants.scss
mais on doit indiquer ici les couleurs au format #rrvvbb
car elles sont parfois passées telles quelles à \textcolor
et mathlive gère ce format mais pas hsl(…)
*/
export const colorEnonce = isDarkMode
  ? '#EBEBEB' // hsl(220 0% 92%)
  : '#222A39' // hsl(220 25% 18%)
/** Couleur des réponses évaluées juste */
export const colorOk = isDarkMode
  ? '#6EF77A' // hsl(125 90% 70%)
  : '#089113' // hsl(125 90% 30%)
/** Couleur des réponses évaluées correctes mais incomplètes (pas simplifié par ex) */
export const colorOkPartial = isDarkMode
  ? '#DDFA6B' // hsl(72 93% 70%)
  : '#6B830C' // hsl(72 83% 28%)
/** Couleur des réponses évaluées comme erronées */
export const colorKo = isDarkMode
  ? '#FF7E53' // hsl(15 96% 65%)
  : '#E03C06' // hsl(15 95% 45%)
/** Couleur utilisée pour afficher la correction */
export const colorCorrection = isDarkMode
  ? '#9F80FF' // hsl(225 100% 75%)
  : '#3366FF' // hsl(225 100% 60%)
/** Couleur utilisée pour des infos de contexte, par ex "il reste n essais" */
export const colorInfo = isDarkMode
  ? '#F29FF2' // hsl(300 65% 75%)
  : '#800080' // hsl(300 100% 25%)

/** Nom de la classe css pour les messages cBien / Cfaux qui doivent rester visible dans MD quand on scrolle */
export const cssStickyFeedback = 'stickyFeedback'
/** Nom de la classe css pour les messages cBien / Cfaux */
export const cssFeedback = 'feedback'
/** Nom de la classe css pour la correction (affichage de la solution) */
export const cssCorrection = 'correction'
/** Nom de la classe css pour un bloc d'infos (avec bordure) */
export const cssInfoBloc = 'infoBloc'
/** Nom de la classe css pour des infos inline (nb essais restants) */
export const cssInfo = 'info'
/** Nom de la classe css pour réponses élève OK */
export const cssOk = 'ok'
/** Nom de la classe css pour réponses élève KO */
export const cssKo = 'ko'
/** Nom de la classe css pour réponses élève ok mais incomplètes */
export const cssOkPartial = 'okPartial'
